export default 'https://api.scryfall.com/cards/'



// WEBPACK FOOTER //
// ./src/mtgApiConfig.js